import React from 'react';






// eslint-disable-next-line react/jsx-no-useless-fragment
const ShowIf = ({ if: condition, children }) => !condition ? /*#__PURE__*/React.createElement(React.Fragment, null) : children;

export default ShowIf;